import { OverlayConfig } from '@angular/cdk/overlay';
import { Component, EventEmitter, Input, Output, ViewChild, ViewChildren, } from '@angular/core';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/overlay";
import * as i2 from "@angular/common";
import * as i3 from "@angular/cdk/portal";
const _c0 = ["dropdownMenuPortal"];
const _c1 = ["listitems"];
function AutocompleteComponent_ng_template_0_li_1_i_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "i");
} if (rf & 2) {
    const viewIcon_r8 = ctx.$implicit;
    i0.ɵɵclassMapInterpolate1("dpg-icon ", viewIcon_r8.class, "");
} }
function AutocompleteComponent_ng_template_0_li_1_p_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(option_r3.viewDescription);
} }
function AutocompleteComponent_ng_template_0_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 4, 5);
    i0.ɵɵlistener("click", function AutocompleteComponent_ng_template_0_li_1_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r11); const option_r3 = restoredCtx.$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r10.selectOption(option_r3)); });
    i0.ɵɵelementStart(2, "a", 6);
    i0.ɵɵlistener("click", function AutocompleteComponent_ng_template_0_li_1_Template_a_click_2_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r12 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r12.linkClick($event)); });
    i0.ɵɵelementStart(3, "span", 7)(4, "strong");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵtemplate(7, AutocompleteComponent_ng_template_0_li_1_i_7_Template, 1, 3, "i", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, AutocompleteComponent_ng_template_0_li_1_p_8_Template, 2, 1, "p", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", ctx_r2.getOptionLabel());
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(option_r3.viewValue);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", option_r3.viewIcons);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", option_r3.viewDescription);
} }
function AutocompleteComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 2);
    i0.ɵɵtemplate(1, AutocompleteComponent_ng_template_0_li_1_Template, 9, 4, "li", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-expanded", ctx_r1.isExpanded);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.options);
} }
export class AutocompleteComponent {
    constructor(overlay) {
        this.overlay = overlay;
        this.closeOnBlur = false;
        this.selectionChange = new EventEmitter();
        this.isExpanded = false;
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
    }
    linkClick(e) {
        e.preventDefault();
    }
    getOptionLabel() {
        return 'aria label';
    }
    selectOption(option) {
        this.selectionChange.emit(option);
        this.hideAutocomplete();
    }
    openMenu(hostInput) {
        this.isExpanded = true;
        this.showAutocomplete(hostInput);
    }
    showAutocomplete(hostInput) {
        if (!(this.overlayRef && this.overlayRef.hasAttached())) {
            const overlayConfig = this.getOverlayConfig(hostInput);
            this.overlayRef = this.overlay.create(overlayConfig);
            if (this.dropdownMenuPortal) {
                this.overlayRef.attach(this.dropdownMenuPortal);
                this.overlayRef
                    .outsidePointerEvents()
                    .pipe(filter(({ target }) => target !== hostInput.nativeElement))
                    .subscribe((_e) => {
                    this.hideAutocomplete();
                });
            }
        }
    }
    getOverlayConfig(hostInput) {
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(hostInput)
            .withPush(false)
            .withFlexibleDimensions(false)
            .withPositions([{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' }]);
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        const width = hostInput.nativeElement.offsetWidth;
        const overlayConfig = new OverlayConfig({ scrollStrategy, positionStrategy, width });
        return overlayConfig;
    }
    hideAutocomplete() {
        this.isExpanded = false;
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
    }
}
AutocompleteComponent.ɵfac = function AutocompleteComponent_Factory(t) { return new (t || AutocompleteComponent)(i0.ɵɵdirectiveInject(i1.Overlay)); };
AutocompleteComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AutocompleteComponent, selectors: [["mhe-autocomplete"]], viewQuery: function AutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownMenuPortal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.listitems = _t);
    } }, inputs: { options: "options", closeOnBlur: "closeOnBlur" }, outputs: { selectionChange: "selectionChange" }, decls: 2, vars: 0, consts: [["cdkPortal", ""], ["dropdownMenuPortal", "cdkPortal"], ["role", "menu", 1, "dropdown-menu", "list-items-container"], ["role", "presentation", 3, "click", 4, "ngFor", "ngForOf"], ["role", "presentation", 3, "click"], ["listitems", ""], ["role", "menuitem", "href", "", 1, "dropdown-item", 3, "click"], ["aria-hidden", "true"], [3, "class", 4, "ngFor", "ngForOf"], ["aria-hidden", "true", 4, "ngIf"]], template: function AutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, AutocompleteComponent_ng_template_0_Template, 2, 2, "ng-template", 0, 1, i0.ɵɵtemplateRefExtractor);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.CdkPortal], styles: ["ul[_ngcontent-%COMP%]{display:block;width:100%}\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutocompleteComponent, [{
        type: Component,
        args: [{ selector: 'mhe-autocomplete', template: "<ng-template cdkPortal #dropdownMenuPortal=\"cdkPortal\">\n  <ul role=\"menu\" class=\"dropdown-menu list-items-container\" [attr.aria-expanded]=\"isExpanded\">\n    <li\n      *ngFor=\"let option of options; let i = index\"\n      #listitems\n      role=\"presentation\"\n      (click)=\"selectOption(option)\"\n    >\n      <a\n        class=\"dropdown-item\"\n        role=\"menuitem\"\n        href=\"\"\n        [attr.aria-label]=\"getOptionLabel()\"\n        (click)=\"linkClick($event)\"\n      >\n        <span aria-hidden=\"true\">\n          <strong>{{ option.viewValue }}</strong>\n          <span>\n            <i *ngFor=\"let viewIcon of option.viewIcons\" class=\"dpg-icon {{ viewIcon.class }}\"></i>\n          </span>\n        </span>\n        <p *ngIf=\"option.viewDescription\" aria-hidden=\"true\">{{ option.viewDescription }}</p>\n      </a>\n    </li>\n  </ul>\n</ng-template>\n", styles: ["ul{display:block;width:100%}/*# sourceMappingURL=autocomplete.css.map */\n"] }]
    }], function () { return [{ type: i1.Overlay }]; }, { options: [{
            type: Input
        }], closeOnBlur: [{
            type: Input
        }], selectionChange: [{
            type: Output
        }], listitems: [{
            type: ViewChildren,
            args: ['listitems']
        }], dropdownMenuPortal: [{
            type: ViewChild,
            args: ['dropdownMenuPortal', { static: true }]
        }] }); })();
